(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-complementary-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-complementary-products')) {
    customElements.define('bd-complementary-products', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.bd-complements__list') || this.loading) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          }, { rootMargin: '200px' });
          this.observer.observe(this);
        } else {
          this.load();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.loading = false;
      }
      async load() {
        if (this.loading) return;
        this.loading = true;
        this.controller = new AbortController();
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Recommendation request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = page.getElementById(this.id);
          if (!this.isConnected) return;
          this.replaceChildren(...(content?.querySelector('.bd-complements__list') ? Array.from(content.childNodes) : []));
        } catch (error) {
          if (error.name !== 'AbortError') this.replaceChildren();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bd-gel-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-gel-finder')) {
    customElements.define('bd-gel-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.grid = this.querySelector('.bd-gels__grid');
        this.group = '';
        this.colors = [];
        this.cards.forEach(card => {
          try { card.gelGroups = JSON.parse(card.dataset.groups) || ['construction']; } catch { card.gelGroups = ['construction']; }
          try { card.gelColors = JSON.parse(card.dataset.colors) || []; } catch { card.gelColors = []; }
          this.updateVariant(card);
        });
        this.querySelector('[data-controls]').hidden = false;
        this.addEventListener('click', event => {
          const groupButton = event.target.closest('[data-group]');
          if (groupButton) {
            this.group = this.group === groupButton.dataset.group ? '' : groupButton.dataset.group;
            this.applyFilters(true);
          }
          if (event.target.closest('[data-reset]')) {
            this.group = '';
            this.colors = [];
            this.querySelectorAll('[data-color]').forEach(input => input.checked = false);
            this.querySelector('[data-viscosity]').value = '';
            this.querySelector('[data-stock-only]').checked = false;
            this.applyFilters(true);
          }
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-variant]')) {
            this.updateVariant(event.target.closest('[data-card]'));
            this.applyFilters(false);
            return;
          }
          this.colors = Array.from(this.querySelectorAll('[data-color]:checked'), input => input.value);
          this.applyFilters(true);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('.bd-gel-card__form')) return;
          event.preventDefault();
          this.addToCart(event.target);
        });
        this.onPopState = () => this.readUrl();
        window.addEventListener('popstate', this.onPopState);
        this.readUrl();
      }
      disconnectedCallback() { if (this.onPopState) window.removeEventListener('popstate', this.onPopState); }
      readUrl() {
        const params = new URL(window.location.href).searchParams;
        const group = params.get('bd_gel') || '';
        this.group = ['monophase', 'construction', 'fiber'].includes(group) ? group : '';
        const colors = (params.get('bd_couleur') || '').split(',');
        this.querySelectorAll('[data-color]').forEach(input => input.checked = colors.includes(input.value));
        this.colors = Array.from(this.querySelectorAll('[data-color]:checked'), input => input.value);
        const viscosity = params.get('bd_viscosite') || '';
        this.querySelector('[data-viscosity]').value = ['semi_epaisse', 'epaisse'].includes(viscosity) ? viscosity : '';
        this.querySelector('[data-stock-only]').checked = params.get('bd_stock') === '1';
        this.applyFilters(false);
      }
      applyFilters(updateUrl) {
        const viscosity = this.querySelector('[data-viscosity]').value;
        const stockOnly = this.querySelector('[data-stock-only]').checked;
        this.querySelectorAll('[data-group]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.group === this.group)));
        let count = 0;
        this.cards.forEach(card => {
          const match = (!this.group || card.gelGroups.includes(this.group)) && (!this.colors.length || this.colors.some(color => card.gelColors.includes(color))) && (!viscosity || card.dataset.viscosityKey === viscosity) && (!stockOnly || card.dataset.available === 'true');
          card.hidden = !match;
          if (match) count += 1;
        });
        const sort = this.querySelector('[data-sort]').value;
        const ordered = [...this.cards].sort((a, b) => sort === 'best' ? Number(a.dataset.position) - Number(b.dataset.position) : (Number(a.dataset.priceNumber) - Number(b.dataset.priceNumber)) * (sort === 'price_desc' ? -1 : 1));
        ordered.forEach(card => this.grid.append(card));
        this.querySelector('[data-result-count]').textContent = count + ' ' + this.dataset.countLabel;
        this.querySelector('[data-empty]').hidden = count !== 0;
        if (updateUrl) {
          const url = new URL(window.location.href);
          const values = {bd_gel: this.group, bd_couleur: this.colors.join(','), bd_viscosite: viscosity, bd_stock: stockOnly ? '1' : ''};
          Object.entries(values).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
          window.history.replaceState(window.history.state, '', url);
        }
      }
      updateVariant(card) {
        const select = card.querySelector('[data-variant]');
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        card.querySelector('[data-price]').textContent = option.dataset.price;
        card.dataset.priceNumber = option.dataset.priceNumber;
        card.querySelector('[data-availability]').textContent = available ? this.dataset.stockLabel : this.dataset.soldLabel;
        const button = card.querySelector('[type=submit]');
        button.disabled = !available;
        button.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        card.querySelector('[data-message]').textContent = '';
        card.querySelectorAll('[data-product-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', option.value);
          link.href = url.href;
        });
      }
      async addToCart(form) {
        if (form.dataset.busy === 'true') return;
        const card = form.closest('[data-card]');
        const select = form.querySelector('[data-variant]');
        if (!select.selectedOptions[0] || select.selectedOptions[0].dataset.available !== 'true') return;
        const button = form.querySelector('[type=submit]');
        const message = form.querySelector('[data-message]');
        const cartLink = form.querySelector('[data-cart-link]');
        const formData = new FormData(form);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        }
        form.dataset.busy = 'true';
        select.disabled = true;
        button.disabled = true;
        button.textContent = this.dataset.addingLabel;
        message.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {method: 'POST', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: formData});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
          message.textContent = this.dataset.addedLabel;
          cartLink.hidden = false;
          if (cart && result.sections && typeof cart.renderContents === 'function') {
            try { cart.renderContents(result); cart.classList.remove('is-empty'); } catch { cartLink.focus(); }
          }
          document.dispatchEvent(new CustomEvent('variant:add', {detail: {variant: {id: formData.get('id')}, quantity: 1, formElement: form}}));
        } catch (error) {
          message.textContent = error.message || this.dataset.errorLabel;
        } finally {
          form.dataset.busy = 'false';
          select.disabled = false;
          button.disabled = select.selectedOptions[0].dataset.available !== 'true';
          button.textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
